module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"table":{"allLabel":"All","placeholderLabel":"There are no tasks","headers":{"name":"Task name","service":"Service","priority":"Priority","complianceSection":"Compliance section","actionBy":"Action by","dueDate":"Due date"},"confirm":{"delete":"Are you sure you want\\nto permanently delete this task?"},"hints":{"dueDate":"Complete the task by that date to be compliant"}}}}')
  delete Component.options._Ctor
}
